<template>
  <div>
    <div class="tab-item-container" v-if="classes.data.length > 0">
      <div v-if="!hasAssignClass">
        <div class="class-info-container">
          <div  class="class-info">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn flat text class="branded-text" v-on="on" @click="hotlinkAssignCourse">
                  No class selected.
                </v-btn>
              </template>
              <span class='text--white'>Select Class</span>
            </v-tooltip>
          </div>
        </div>
      </div>
      <div v-if="hasAssignClass">
        <div v-if="assignClass.lmsType === null || assignClass.lmsType === 'Google' || assignClass.lmsType === 'SchoologyFree' || assignClass.lmsType === 'Clever'">
          <div class="class-info-container" >
            <div class="class-info">
              <p>{{shareInfo}}
                <span class="icon-div">
                  <v-icon :color="assignClass.default_color" size="20">folder_shared</v-icon>
                </span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span @click="hotlinkAssignCourse" v-on="on" class="selectable">{{assignClass.name}}</span>
                  </template>
                  <span style="color:#fff">Change Class</span>
                </v-tooltip>
              </p>
            </div>
          </div>
          <div class="copy-container" v-if="hasAssignClass">
            <v-text-field  box hide-details readonly :value="shareUrl"></v-text-field>
            <ClipboardCopy :copyText="shareUrl"></ClipboardCopy>
          </div>
          <div
            id="playlistAdvancedContainer"
            :class="{'mb-5': !this.customLogin, 'mb-6': this.customLogin}">
            <v-flex>
              <v-btn
                v-if="assignClass.lmsType === 'Google'"
                @click="createGoogleAssignment"
                large
                flat
                class="ml-0 mb-5">
                  <v-avatar
                    tile
                    size=32
                    class="mr-2">
                    <img src="https://bunny.playposit.com/images/add_to_googleclassroom.png" alt="Google Classroom Logo">
                  </v-avatar>
                  Share to Classroom
                </v-btn>
            </v-flex>
            <a class="link-button" @click="openAdvancedMenu">Advanced settings</a>
            <v-container
              v-show="advancedShow" pl-3 pt-0>
              <v-layout>
                <v-flex>
                  <v-switch
                    v-if="hasSamlLogin"
                    v-model="samlLogin"
                    @change="handleCustomOrSAMLToggled('saml')"
                    label="Require SAML Login"
                    height="30"></v-switch>
                  <v-switch
                    v-if="hasCustomLoginToggle"
                    v-model="customLogin"
                    @change="handleCustomOrSAMLToggled('custom')"
                    label="Require custom login"
                    height="30"></v-switch>
                  <v-switch  v-model="embed" label="Show Embed Code" height="30"></v-switch>
                  <div class="advanced-section"  v-if="school.id != null">
                    <v-radio-group v-model="assignLink" @change="savePlaylistSectionConfig" :disabled="authenticate || savingConfig">
                      <v-radio
                        label="Learners - This option requires viewers to log in to a PlayPosit learner account. Data will be saved."
                        value="learners">
                      </v-radio>
                      <v-radio
                        label="Instructors - This option requires viewers to log in to a PlayPosit instructor account.  Use this option when assigning playlists for professional learning. Data will be saved."
                        value="instructors">
                      </v-radio>
                      <v-radio
                        label="Public - This option will not require log in. Data will be saved."
                        value="open">
                      </v-radio>
                      <v-switch
                        v-if="assignLink === 'open'"
                        class="ml-4 mt-0 mb-2"
                        v-model="isAnonymous"
                        label="Do not require learner name"
                        height="30"
                        @change="savePlaylistSectionConfig">
                      </v-switch>
                      <v-radio
                        label="Instructor OR Learner - This option requires viewers to log in to either a PlayPosit instructor or learner account. Data will be saved."
                        value="anyLogin"
                        class="mb-2">
                      </v-radio>
                    </v-radio-group>
                  </div>
                </v-flex>
                <v-flex :style="{ minHeight: '260px' }">
                  <Tooltip
                  right
                  tag="div">
                  <canvas @click="copyQRCode" id="qrCode"></canvas>
                  <template v-slot:text>
                    Click to copy QR Code.
                  </template>
                  </Tooltip>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </div>
        <div class="tab-item-container" v-if="assignClass.lmsType != null && assignClass.lmsType != 'Google' && assignClass.lmsType != 'SchoologyFree' && assignClass.lmsType != 'Clever'">
          <div class="no-class-container">
            <h3 class="padding-rig,ht">This course was created in {{assignClass.lmsType}}. Share and assign playlists in {{assignClass.lmsType}}.</h3>
            <v-btn icon flat class="branded-text" href="https://knowledge.playposit.com/category/219-playposit-30-in-your-lms" target="_blank">
              <v-icon>info</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-item-container" v-if="classes.data.length === 0">
      <div class="no-class-container">
        <h3 class="padding-right">No classes found.</h3>
        <v-btn flat text class="branded-background text-white" @click="hotlink('shareMenu', 'addMenu', 'add')">
            Create Class
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
/* global _ */
/* global moment, navigator, ClipboardItem */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import QRCode from 'qrcode';
import Hashids from 'hashids';

const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

import ClipboardCopy from '@/components/buttons/clipboardCopy';

export default {
  name: 'PlaylistAssignLink',
  components: { 
    ClipboardCopy,
  },
  props: [ 
    'assignClass',
    'hotlink', // this should be a mixin
    'hotlinkAssignCourse',
    'playlist'
  ], 
  data() {
    return {
      advancedShow: false,
      authenticate: false, // Future sprint
      assignLink: 'learners',
      colleague: false,
      customLogin: false,
      embed: false,
      isAnonymous: false,
      join: false,
      name: false, // Future sprint
      pdLink: false,
      playlistSection: {},
      savingConfig: false,
      samlLogin: false,
    };
  },
  computed: {
    ...mapState('instructors', [
      'playlistAssignedDates',
    ]),
    ...mapGetters([
      'instructorData',
      'school',
      'phpApiPrefix',
    ]),
    ...mapGetters('instructors', [
      'classes',
      'hasSamlLogin',
      'hasIdpLearnerUrl',
    ]),
    hasAssignClass() {
      return Object.keys(this.assignClass).length > 0;
    },
    hasCustomLoginToggle() {
      return _.get(this, 'school.permissionKeys', []).includes('customLoginAssignToggle');
    },
    courseHash() {
      return hashids.encode([this.playlist.id, this.assignClass.id]);
    },
    sharePlaylistName() {
      //replace spaces with dashes
      return this.playlist.name.replace(/\s/g, '-').replace(/\//g, '-').replace(/[^a-zA-Z0-9-]/g, '');
    },
    shareCourseName() {
      //create default share course name for listcode
      return `${this.playlist.name} ${moment().format("MMM YYYY")}`;
    },
    shareInfo() {
      //message for share advanced settings
      if (this.samlLogin) {
          return 'Learners will be prompted to login using your SAML Portal, then redirected to the playlist.';
      } else if (this.customLogin) {
        return 'Learners will be prompted to login using your custom portal, then redirected to the playlist.';
      }

      if (Object.keys(this.assignClass).length === 0) {
        if(!this.pdLink && !this.authenticate && !this.join && !this.name){
          return `Learners will be prompted to join a class before playlist plays`
        } else if (this.pdLink){
          return `Colleagues will be prompted to join a class before playlist plays`
        } else if (this.authenticate && !this.join && !this.name) {
          return `Learners will not be required to log in, but will be prompted to enter name and join a class`
        } else if (this.authenticate && this.join && !this.name) {
          return `Learners will not be required to log in or join a class, but will be required to enter name. Data will be saved to an auto-generated class "${this.shareCourseName}"`
        } else if (this.authenticate && !this.join && this.name) {
          return `Learners will not be required to log in or enter name, but will be prompted to join a class`
        } else if (this.authenticate && this.join && this.name) {
          return `Learners will not be required to log in, enter name, or join a class. Data will be saved to an auto-generated class "${this.shareCourseName}"`
        } else {
          return `Learners will be prompted to join a class before playlist plays.`
        }
      } else {
        if (!this.pdLink && !this.authenticate && !this.join && !this.name) {
          return `Learners and their data will be added to the class:`
        } else if (this.pdLink) {
          return `Colleagues and their data will be added to the class:`
        }  else if (this.authenticate && !this.name) {
          return `Learners will not be required to log in, but will enter their names. Data will be saved to the class:`
        } else if (this.authenticate && this.name) {
          return `Learners will not be required to log in or enter their names, and their responses will be saved to the class:`
        } else {
          return `Learners and their data will be added to the class:`
        }
      }
    },
    shareUrl() {

      let link = "";
      if (this.samlLogin) {
         if(this.hasIdpLearnerUrl) {
          link = `${this.phpApiPrefix}/saml/${this.school.id}/learner?redirect=/playlist/${this.courseHash}`;
        } else {
          link = `${this.phpApiPrefix}/saml/${this.school.id}?redirect=/playlist/${this.courseHash}`;
        }
      } else if (this.customLogin) {
        const redirectURL = encodeURIComponent(`/playlist/${this.courseHash}`);
        link = `${this.phpApiPrefix}/account/learner/login?school_id=${this.school.id}&redirect=${redirectURL}`;
      } else {
        link = `${this.phpApiPrefix}/playlist/${this.courseHash}`;
      }

      if (this.embed) return `<iframe width="768" height="597" scrolling="no" src="${link}" allow="autoplay *;" allowfullscreen frameborder="0"></iframe>`;
      return link;
    }
  },
  methods: {
    ...mapMutations([
      'triggerSnackbar',
    ]),
    ...mapActions('instructors', [
      'updatePlaylistSection',
      'getPlaylistSection',
    ]),
    async copyQRCode() {
      const canvas = document.getElementById('qrCode');
      canvas.toBlob((blob) => {
        let data = [new ClipboardItem({ [blob.type]: blob })];
        navigator.clipboard.write(data).then(() => {
          this.triggerSnackbar({
            text: 'QR Code copied!',
            color: 'success',
            timeout: 3500,
          });
        }, function (err) {
          throw err;
        });
      });
    },
    async createGoogleAssignment(pathName) {
      try {
        let state = {
          playlistId: this.playlist.id,
          playlistName: this.playlist.name,
          googleCourseId: this.assignClass.key.substring(1),
          assignedDate: _.find(this.playlistAssignedDates, { sectionId: this.assignClass.id }).assignedDate || '',
          sectionId: this.assignClass.id,
          contentType: 'playlist',
        };
        state = encodeURIComponent(JSON.stringify(state));
        const left = window.screenX + 650;
        const top = window.screenY + 15;
        window.open(`${window.location.origin}/dash/googleAssignmentPicker?state=${state}`, 'googleAuth', `width=900, height=1000, top=${top}, left=${left}`);
      } catch(e) {
        this.triggerSnackbar({
          text: 'Error authorizing with Google.',
          color: 'error',
          timeout: 5000,
        });
        setTimeout(() => {
          window.close();
        }, 3000);
      }
    },
    async createQRCode() {
      try {
        const qrElement = document.getElementById('qrCode');
        await QRCode.toCanvas(qrElement, this.shareUrl, {
          errorCorrectionLevel: 'H',
        });
      } catch (err) {
        const qrElement = document.getElementById('qrCode');
        qrElement.style.display = 'none';
        console.error(err);
      }
    },
    handleCustomOrSAMLToggled(type) {
      if (type === 'custom') this.samlLogin = false;
      else this.customLogin = false;
    },
    openAdvancedMenu() {
      this.advancedShow = !this.advancedShow;
      if (this.advancedShow) this.createQRCode();
    },
    async savePlaylistSectionConfig() {
      this.savingConfig = true;
      try {
        const newConfig = {
          anonymous: this.isAnonymous,
          audience: this.assignLink
        };
        await this.updatePlaylistSection({
          playlistId: this.playlist.id,
          sectionId: this.assignClass.id,
          newConfig
        });
      } catch (e) {
        this.triggerSnackbar({
          text: 'Error updating playlist audience.',
          color: 'error',
          timeout: 3000,
        });
      } finally {
        this.savingConfig = false;
      }
    },
  },
  watch: {
    'embed' (n, o) {
      const qrElement = document.getElementById('qrCode');
      if (n) qrElement.style.display = 'none';
      if (!n) qrElement.style.display = 'inline-block';
    },
    'shareUrl' (n, o) {
      this.createQRCode();
    },
    'hasAssignClass': async function (n, o) {
      if (this.hasAssignClass) {
        try {
          this.playlistSection = await this.getPlaylistSection({
            playlistId: this.playlist.id,
            sectionId: this.assignClass.id,
          });
          this.assignLink = _.get(this.playlistSection, 'config.audience', 'learners');
          this.isAnonymous = _.get(this.playlistSection, 'config.anonymous', false);
        } catch (e) {
          this.triggerSnackbar({
            text: 'Error retrieving playlist section data',
            color: 'success',
            timeout: 3500,
          });
        }
      }
    },
  },
  mounted() {
    this.samlLogin = _.get(this.school, 'config.enableSamlByDefault', false);
  },
};
</script>

<style>
  .copy-container input {
    margin-top: 6px !important;
    outline: none!important;
  }
  
  .class-info-container{
    width: 100%;
    height: 100px;
  }
  .class-info{
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    padding: 5px 24px 0px 24px;
  }
  
  .class-info p {
    margin-bottom: 0!important;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.64);
  }
  
  .class-info span {
    font-size: 16px;
  }
  
  canvas:hover {
    cursor: pointer;
  }
  
  #playlistAdvancedContainer {
    padding: 0px 24px 16px 24px;
  }

  .mb-6 {
    margin-bottom: 80px;
  }
</style>
